import { render, staticRenderFns } from "./veStuLiteraryAwardEdit.vue?vue&type=template&id=0de74df4&scoped=true"
import script from "./veStuLiteraryAwardEdit.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de74df4",
  null
  
)

export default component.exports